import React from 'react';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Divider from '@mui/material/Divider';

import PrestaGlobals from '../common/PrestaGlobals';
import AddToCartContainer from '../configurator/AddToCartContainer';
import DxfExportButton from '../admin/DxfExportButton';
import AiDesignerTab from './AiDesignerTab';
import ScriptsTab from './ScriptsTab';

/**
 * The side panel of the AI designer page (/ai-designer), in the configurator's place: the AI
 * designer, and the ucon + StyleScript the Designer shows, over the configurator's "Kosárba" bar.
 * Both tabs stay mounted, so a brief being written or an unapplied edit survives a tab switch.
 */
const AiDesignerPanel: React.FC = () => {
    const [tab, setTab] = React.useState(0);

    return (
        <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <Stack direction="row" alignItems="center" spacing={1} sx={{ px: 2, pt: 1.5, pb: 1 }}>
                <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography variant="h6">AI tervező</Typography>
                    <Typography variant="caption" color="text.secondary">
                        Termék #{PrestaGlobals.productId} · {PrestaGlobals.shopName}
                    </Typography>
                </Box>
                <DxfExportButton />
                <Button size="small" href={`${PrestaGlobals.virtualUri}/designer`}>Designer</Button>
            </Stack>
            <Divider />

            <Tabs value={tab} onChange={(_, v) => setTab(v)} variant="fullWidth">
                <Tab label="AI tervező" />
                <Tab label="Szkriptek" />
            </Tabs>

            <Box sx={{ flex: 1, minHeight: 0, overflow: 'auto', p: 2 }}>
                <Box sx={{ display: tab === 0 ? 'block' : 'none' }}><AiDesignerTab /></Box>
                <Box sx={{ display: tab === 1 ? 'block' : 'none', height: '100%' }}><ScriptsTab /></Box>
            </Box>

            <AddToCartContainer />
        </Box>
    );
};

export default AiDesignerPanel;
